export default __webpack_public_path__ + "static/media/icon_friendship.6d884ead.svg";